import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/features/FeaturesContent.tsx");
